import styles from "./Player.module.css";

function prefixInteger(num: number, length: number) {
  return (num / Math.pow(10, length)).toFixed(length).substring(2);
}

export default function TimeV2({ time, isRunning }) {
  if (time == null) {
    return null;
  }

  const sec = time < 10000 ? Math.floor(time / 1000) : Math.ceil(time / 1000);
  const minutes = prefixInteger(Math.floor(sec / 60), 2);
  const seconds = prefixInteger(sec % 60, 2);
  const tenths = Math.floor((time % 1000) / 100);

  const timeStyles = isRunning ? styles.timeTurnV2 : styles.timeV2;

  return (
    <div className={timeStyles}>
      {minutes}:{seconds}
      {time < 10000 && "." + tenths}
    </div>
  );
}
